module.exports = __webpack_public_path__ + "static/img/left-home-row-1.09e57e6d.webp";